<template>
    <span class="theTooltip">
        <button
            type="button"
            class="btn btn-auto tt"
            data-toggle="popover"
            data-trigger="hover"
            data-placement="auto"
            :data-content="text"
            :data-original-title="title"
            @mouseover="showTooltip = true"
            @mouseleave="showTooltip = false"
        >
            <slot @mouseover="showTooltip = true" v-if="content"></slot>
            <a-icon v-else icon="Info" :iconClass="'text-dark'" />
        </button>
        <div
            v-if="showTooltip"
            class="theTooltip__text"
            :class="`${side} ${customClass}`"
        >
            <h6 v-if="title">{{ title }}</h6>
            {{ text }}
        </div>
    </span>
</template>

<script>
export default {
    data() {
        return {
            showTooltip: false
        }
    },
    props: {
        title: {
            type: String,
            required: false
        },
        text: {
            type: String,
            required: true
        },
        side: {
            type: String,
            default: 'right'
        },
        content: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        }
    },
    methods: {
        toggleTooltip() {
            this.showTooltip = !this.showTooltip
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.theTooltip {
    position: relative;
    &__text {
        font-weight: 400;
        min-width: 200px;
        background-color: #fff;
        color: #041e42;
        text-align: left;
        border-radius: 6px;
        padding: 10px 10px;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(0%);
        transition: opacity 0.3s;
        box-shadow: 0px 0px 1px #999;
        font-size: 12px;
        color: #999;
        text-transform: none;
        &:after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #fff transparent transparent transparent;
        }
        &.right {
            left: 100%;
            margin-left: 5px;
            right: 5%;
            top: 50%;
            bottom: auto;
            transform: translateY(-50%);
            &:after {
                top: 50%;
                left: 0%;
                margin-top: -5px;
                margin-left: -10px;
                border-width: 5px;
                border-color: transparent #fff transparent transparent;
            }
            @include media-breakpoint-down(sm) {
                left: 50%;
                margin-bottom: 5px;
                right: 5%;
                bottom: 100%;
                top: auto;
                transform: translateX(-50%);
                &:after {
                    top: 100%;
                    left: 50%;
                    margin-top: -5px;
                    margin-left: -10px;
                    border-width: 5px;
                    border-color: transparent #fff transparent transparent;
                }
            }
        }
        &.bottom {
            left: 50%;
            margin-top: 5px;
            right: 5%;
            top: 100%;
            bottom: auto;
            transform: translateX(-50%);
            &:after {
                top: 100%;
                left: 50%;
                margin-top: -5px;
                margin-left: -10px;
                border-width: 5px;
                border-color: transparent #fff transparent transparent;
            }
        }
    }
}
</style>
